import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const ORDER_CREATED_DATE_FORMAT = 'DD/MM/YYYY';

export const getCurrentMonthCreatedDateFilter = (referenceDate = dayjs()) => {
  const currentDate = dayjs(referenceDate);

  if (!currentDate.isValid()) {
    return {
      date_from: null,
      date_to: null,
    };
  }

  return {
    date_from: currentDate.startOf('month').format(ORDER_CREATED_DATE_FORMAT),
    date_to: currentDate.format(ORDER_CREATED_DATE_FORMAT),
  };
};

export const getOrderCreatedDatePickerRange = (filter = {}) => {
  const startDate = dayjs(filter?.date_from, ORDER_CREATED_DATE_FORMAT, true);
  const endDate = dayjs(filter?.date_to, ORDER_CREATED_DATE_FORMAT, true);

  return startDate.isValid() && endDate.isValid() ? [startDate, endDate] : null;
};

export const getSubmittedOrderListFilter = (currentFilter = {}, submittedFilter = {}) => ({
  ...currentFilter,
  ...submittedFilter,
  page: 1,
});
